import { COLORS } from '@btime/constants'
import React from 'react'

import Image from '../../../../../components/pdf/Image'
import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'

import { getImages, findReplyByQuestionName, getReplyValueFieldOrDefault } from '../../_helpers/pdfHelpers'

const FurnitureSection = ({ serviceOrder }) => {
  const imagemCabos = getImages(findReplyByQuestionName(serviceOrder.replies, 'ORGANIZAÇÃO DOS CABOS ELÉTRICOS'), 0)
  const reply = findReplyByQuestionName(serviceOrder.replies, 'CABOS ELÉTRICOS ESTÃO ORGANIZADOS?')
  const replyCables = getReplyValueFieldOrDefault(reply, 'value', true)

  return (
    <View id="13">
      <Text bold size="small">
        13. PONTOS DE VERIFICAÇÃO ERGONÔMICA
      </Text>

      <Separator weight={8} />

      <Text bold size="small">
        13.1. ORGANIZAÇÃO DE CABOS
      </Text>

      <Separator weight={4} />

      <Text bold size="small">
        AVALIAÇÃO
      </Text>

      <Separator weight={4} />

      <Image src={imagemCabos} maxWidth="300px" maxHeight="350px" ignoreFixedSize />

      <Separator weight={4} />

      <ul>
        <li>
          <Text underlineColor={COLORS.lightGreen}>
            {`Os cabos ${
              replyCables ? 'estão' : 'não estão'
            } organizados com velcro, organizador de cabos ou canaletas, de forma que eles não fiquem soltos ou emaranhados`}
          </Text>
        </li>
      </ul>

      <Separator weight={8} />
    </View>
  )
}

export default FurnitureSection
